import { buildURL } from '../../../../helpers/urls';
import { get } from '../../../../helpers/fetch';

// eslint-disable-next-line import/prefer-default-export
export const getMetrics = () => {
  const url = buildURL('/events/metrics');
  return get(url);
};
